<script setup lang="ts">
import { dir } from '@@/bits/current_dir'
import device from '@@/bits/device'
import { NON_STREAM_STANDARD_MAX_POST_SIZE, NON_STREAM_WIDE_MAX_POST_SIZE } from '@@/bits/post_size'
import { useSurfaceStore } from '@@/pinia/surface'
import type { Post } from '@@/types'
import SurfacePostCompressed from '@@/vuecomponents/SurfacePostCompressed.vue'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

const props = defineProps<{
  post: Post
  isTimelinePreview?: boolean
  width?: number
}>()

const { isPostSizeWide } = storeToRefs(useSurfaceStore())
const width = computed(() => {
  if (props.width) return props.width
  return isPostSizeWide.value ? NON_STREAM_WIDE_MAX_POST_SIZE : NON_STREAM_STANDARD_MAX_POST_SIZE
})
</script>

<template>
  <SurfacePostCompressed
    :post="post"
    :dir="dir()"
    :class="[!device.ios && '-rotate-1']"
    :is-timeline-preview="isTimelinePreview"
    :rounded-borders="!device.ios"
    :style="{ width: `${width}px` }"
  />
</template>
